module.exports = __webpack_public_path__ + "static/img/3.7fb51c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R141B/3.jpg
// module id = 7Aby
// module chunks = 1